import { useEffect, useState } from 'react';

import { useSpainClosurePeriods } from 'src/core/modules/bookkeep/apis/useSpainClosurePeriods';
import { type SpanishDprSettingsResponse } from 'src/core/modules/bookkeep/apis/useSpanishDprSettings';
import { useSpanishDprStartDateQuery } from 'src/core/modules/bookkeep/apis/useSpanishDprStartDate';

import { SpanishDprSetupEndYearDate } from './SpanishDprEndYeadDate/SpanishDprSetupEndYearDate';
import { SpanishDprUpdateEndYeadDate } from './SpanishDprEndYeadDate/SpanishDprUpdateEndYeadDate';
import { SpanishDprPeriodsList } from './SpanishDprPeriodsList';
import {
  type SanitizedSpainClosurePeriod,
  sanitizePeriodsList,
} from './helpers/sanitizePeriodsList';

export function SpanishDprArchiving({
  currentSettings,
}: {
  currentSettings: SpanishDprSettingsResponse | undefined;
}) {
  const [periods, setPeriods] = useState<SanitizedSpainClosurePeriod[]>([]);

  const firstSpanishDprPayableDate = useSpanishDprStartDateQuery();

  const { periods: closurePeriods } = useSpainClosurePeriods();
  const {
    fiscalYearEndMonth: monthFromSettings = null,
    fiscalYearEndDay: dayFromSettings = null,
  } = currentSettings?.settings || {};

  const fiscalYearEndSet =
    monthFromSettings !== null && dayFromSettings !== null;

  useEffect(() => {
    if (fiscalYearEndSet) {
      const sanitizedPeriodsList = sanitizePeriodsList(
        monthFromSettings,
        dayFromSettings,
        firstSpanishDprPayableDate,
        closurePeriods,
      );
      setPeriods(sanitizedPeriodsList);
    }
  }, [
    monthFromSettings,
    dayFromSettings,
    firstSpanishDprPayableDate,
    closurePeriods,
  ]);

  const isDateEditable = !periods.some((period) =>
    ['completed', 'ongoing', 'pending'].includes(period.state),
  );
  if (fiscalYearEndSet) {
    return (
      <>
        <SpanishDprUpdateEndYeadDate
          initialMonth={monthFromSettings}
          initialDay={dayFromSettings}
          isEditable={isDateEditable}
        />
        <SpanishDprPeriodsList periods={periods} />
      </>
    );
  }

  return <SpanishDprSetupEndYearDate />;
}
